export default __webpack_public_path__ + "static/sageCrmImage-6f8aa9fd8ffa141f32aa665c109a5579.webp";